import { style } from "@vanilla-extract/css";
import { borderedCell, textTruncate } from "plos/src/styles";
import { stickyListColumn } from "plos/src/styles/listTables.css";
import { vars } from "plos/src/styles/theme.css";

export const entryTableElement = style([
  stickyListColumn,
  textTruncate,
  borderedCell,
  {
    backgroundColor: vars.colors.surface,
  },
]);

export const elementContentWrapper = style({
  display: "flex",
  alignItems: "center",
  width: "100%",
  minWidth: 0,
});

export const elementInTableWrapper = style([
  textTruncate,
  {
    flexGrow: 1,
    minWidth: 0,
  },
]);
